import { Injectable } from '@angular/core';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import { NgConfirmationDialogComponent } from '../_directives/ng-confirmation-dialog/ng-confirmation-dialog.component'
@Injectable()
export class ConfirmationDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(title: String, message: String, onSuccessCallback:Function, onCancelCallback: Function, warning?: boolean) {
   
    const modalRef = this.modalService.open(NgConfirmationDialogComponent)
    modalRef.componentInstance.title = title
    modalRef.componentInstance.message = message
    console.log(warning);
    if(warning) {
    modalRef.componentInstance.warning = true;
    }
    modalRef.result.then((result) => {
      if(result) {
        onSuccessCallback()
      } else {
        onCancelCallback()
      }
    }, (reason) => {
      if(!warning) {
        onCancelCallback()
      }
    })
  }

}
